<div class="container">
  <div class="header">
    <button type="button" class="card-title-link" (click)="navigateToContractorsList()">
      <span class="ct-badge"><i class="material-icons">groups</i></span>
      <span class="ct-text">{{ pageTitle }}</span>
      <i class="material-icons ct-arrow">chevron_right</i>
    </button>
    <div class="fs-field">
      <span class="fs-label">Month</span>
      <select class="native-select has-icon icon-cal" aria-label="Month" (change)="valueSelect($any($event.target).value)">
        <option *ngFor="let m of month" [value]="m.label" [selected]="m.value === selectedMonth">{{ m.label }}</option>
      </select>
    </div>
  </div>

  <div class="headcount-tiles">
    <div class="hc-tile" data-tone="neutral">
      <div class="hc-value">{{ totalContractor }}</div>
      <div class="hc-label">{{ total }}</div>
    </div>
    <div class="hc-tile" data-tone="success">
      <div class="hc-value">{{ contractorOnBoarded }}</div>
      <div class="hc-label">{{ onBoarded }}</div>
    </div>
    <div class="hc-tile" data-tone="warning">
      <div class="hc-value">{{ contractorOffBoarded }}</div>
      <div class="hc-label">{{ offBoarded }}</div>
    </div>
  </div>
</div>